import { useEffect } from 'react';

const ORIGIN = 'https://emboscale.com';

// Apache 301s /foo → /foo/, so the canonical must be the trailing-slash form —
// otherwise canonical and og:url both point at a redirect.
const withSlash = (p) => (p === '/' ? '/' : p.replace(/\/?$/, '/'));

// ponytail: DOM-effect SEO tags instead of react-helmet — the prerender snapshot
// captures post-effect DOM, so crawlers see these without an extra dependency.
const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const Seo = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'robots', noindex ? 'noindex' : 'index, follow');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    // No path (404s, missing posts): no canonical, or Google may fold the URL into the homepage.
    if (path == null) {
      canonical?.remove();
      return;
    }
    setMeta('property', 'og:url', ORIGIN + withSlash(path));
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', ORIGIN + withSlash(path));
  }, [title, description, path, noindex]);
  return null;
};

export default Seo;
